import { render } from "./package_and_hotel_item.vue?vue&type=template&id=28fce6fb"
import script from "./package_and_hotel_item.vue?vue&type=script&lang=js"
export * from "./package_and_hotel_item.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__